import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { AuthSignUp } from "@/components/features/auth/sign-up";

export const AuthSignUpPage = () => {
	return (
		<PageMeta title="" url={PATHS.AUTH.SIGN_UP}>
			<AuthSignUp />
		</PageMeta>
	);
};
